module.exports = __webpack_public_path__ + "static/crowdlarge-686cbb37cc0125a87747e65af12bea3f.jpg";